import React from 'react';
import styled from 'styled-components';
import Tooltip from '../Tooltip';

const EntityButton = styled.div`
  display: flex;
  border: 1px solid transparent;
  cursor: pointer;

  padding: 2px 1px;
  border-radius: 4px;

  &:hover {
    border: 1px solid var(--color-grey-5);
    background-color: var(--color-bg-primary);
  }
`;

const Interaction = ({
  text,
  onClick,
  tooltip,
}: {
  text: string;
  onClick: (event: any) => void;
  tooltip?: string;
}) => (
  <Tooltip content={tooltip}>
    <EntityButton onClick={onClick}>
      <span style={{ color: 'var(--color-info-v2)' }}>{text}</span>
    </EntityButton>
  </Tooltip>
);

export default Interaction;
